<template>
  <v-dialog
    :value="shownRelay"
    :persistent="true"
    width="400"
  >
    <v-card>
      <v-progress-linear
        v-if="savingChanges"
        color="primary"
        indeterminate
      ></v-progress-linear>

      <v-card-title class="dlg-title-bar">
        Add New Employee
      </v-card-title>

      <v-card-text class="pt-3">
        <v-form ref="createEmployeeForm" @submit="$event.preventDefault()">
          <v-text-field
            ref="employeeName"
            dense
            outlined
            color="primary"
            v-model="value.name"
            label="Employee Name"
            placeholder="eg. Beth Smith"
            :rules="[validationRules.required, duplicateEmployeeName]"
            :readonly="savingChanges"
          ></v-text-field>

          <v-text-field
            ref="employeeNumber"
            dense
            outlined
            color="primary"
            v-model="value.employeeNumber"
            :readonly="savingChanges"
            label="Company Employee Number"
            :rules="[duplicateEmployeeNumber]"
          ></v-text-field>

          <div class="d-flex align-start">
            <v-autocomplete
              class="flex-grow-1"
              dense
              outlined
              color="primary"
              v-model="value.teamId"
              label="Team"
              placeholder="eg. Finance"
              :items="sortedTeams"
              item-text="name"
              item-value="_id"
              :rules="[validationRules.required]"
            ></v-autocomplete>
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn
                  class="ml-2"
                  icon
                  color="primary"
                  v-on="on"
                  @click="showCreateTeam = true"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              Create new Team
            </v-tooltip>
          </div>
          <!--Create New Team-->
          <app-team-add v-if="showCreateTeam" :shown.sync="showCreateTeam" :show-employees="false" @input="value.teamId = $event._id"/>



          <v-autocomplete
            v-if="showDevices"
            dense
            outlined
            color="primary"
            v-model="addDevices"
            label="Devices"
            placeholder="eg. Rick Sanchez Laptop"
            :items="availableDevices"
            item-text="name"
            item-value="_id"
            chips
            small-chips
            deletable-chips
            multiple
          >
            <template v-slot:item="{item}">
              <v-list-item-avatar>
                <v-icon>mdi-cellphone-link</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"/>
                <v-list-item-subtitle v-text="item.hardwareDescription"/>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-form>
      </v-card-text>
      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          class="ml-2"
          small
          color="primary"
          @click="shownRelay = false"
          outlined
          size="small"
          :disabled="savingChanges"
        >
          Cancel
        </v-btn>

        <v-btn
          @click="createEmployee"
          small
          class="ml-2"
          color="secondary"
          variant="contained"
          size="small"
          :disabled="savingChanges"
          :loading="savingChanges"
        >
          Add New Employee
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {Employee} from "@/models/employee";
import {nameSort, validationRules} from "@/core/codeFunctions";
import {mapGetters} from "vuex";
import AppTeamAdd from "@/components/Teams/AppTeamAdd";

export default {
  components: {AppTeamAdd},
  props: {
    shown: Boolean,
    showDevices: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      savingChanges: false,
      value: new Employee({}),
      validationRules: validationRules,
      addDevices: [],
      showCreateTeam: false,
    }
  },
  watch: {
    shown: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {this.$refs.createEmployeeForm.resetValidation();})
          this.addDevices = [];
          this.value = new Employee({});
          setTimeout(() => {
            this.$refs.employeeName.focus()
          }, 500)
        }
      }
    }
  },
  methods: {
    async createEmployee() {
      if (!this.$refs.createEmployeeForm.validate())
        return;

      try {
        this.savingChanges = true;
        const {_id} = await this.value.create(this.addDevices);
        const addedEmployee = await this.employees.once(_id)
        this.$emit('input', addedEmployee)
        this.shownRelay = false
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError();
      } finally {
        this.savingChanges = false
      }
    },

    duplicateEmployeeName(val) {
      if (!val)
        return 'Required value'
      const employeeNames = this.employees.map(emp => (emp.name || '').toLowerCase())
      if (employeeNames.includes((val || '').toLowerCase()))
        return 'Employee name has already been used'
      return true
    },
    duplicateEmployeeNumber(val) {
      if (!val)
        return true
      const employeeNUmber = this.employees.map(emp => (emp.employeeNumber || '').toLowerCase());
      if (employeeNUmber.includes((val || '').toLowerCase()))
        return 'Employee number has already been used';
      return true;
    },
  },
  computed: {
    ...mapGetters(['employees', 'teams', 'devices', 'teamsWithAccess']),
    sortedTeams() {
      return [...this.teamsWithAccess].sort(nameSort)
    },
    shownRelay: {
      get() {return this.shown},
      set(val) {this.$emit('update:shown', val)}
    },
    availableDevices() {
      return this.devices.filter(dev => !dev.employeeId).sort(nameSort)
    },
  },
}
</script>

<style scoped>

</style>